import { createTheme } from '@mui/material/styles';
import '@fontsource/inter';
import '@fontsource/nunito';
import { pink } from '@mui/material/colors';

const theme = createTheme({
  typography: {
    body1: {
      fontFamily: 'Nunito',
      lineHeight: '32px',
    },
  },
  palette: {
    secondary: {
      main: pink[400],
    },
    info: {
      main: '#4B429F',
    },
  },
});

export default theme;
